import { render, staticRenderFns } from "./LikeMemberComponent.vue?vue&type=template&id=d870e15a&scoped=true"
import script from "./LikeMemberComponent.vue?vue&type=script&lang=js"
export * from "./LikeMemberComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d870e15a",
  null
  
)

export default component.exports